// extracted by mini-css-extract-plugin
export default {"galleryPageContent":"gallery_galleryPageContent__o+H6c"};